import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Url from '../../data/url';
import TopHeaderWithPrev from '../../component/common/TopHeaderWithPrev';
import FullHeightContainer from '../../component/common/FullHeightContainer';
import WirteModal from '../../component/community/WirteModal';
import IcFloatingWrite from '../../assets/image/ic_pen.svg';
import Event from '../../component/community/event/Event';
import Qna from '../../component/community/qna/Qna';
import FreeBoardList from '../../component/community/freeboard/FreeBoard';
import BottomNavigationV2 from '../../component/common/BottomNavigationV2';
import { BOTTOM_NAVI_V2 } from '../../data/define';
import { useTranslation } from '../../hook/useTranslation';

function CommunityPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<'event' | 'qna' | 'freeBoard'>('qna');
  const headerRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null); // 컨테이너 참조용
  const [headerHeight, setHeaderHeight] = useState(0);

  const [writeModalOpen, setWriteModalOpen] = useState(false);

  useEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
  }, []);

  return (
    <FullHeightContainer>
      <div ref={headerRef} className="fixed top-0 left-0 right-0 z-50 bg-white min-w-[300px]">
        <TopHeaderWithPrev title={t('my.community')} onClickPrev={() => navigate(Url.Home)} />
        <div className="w-full flex items-center justify-between border-b border-[#EAEAEA] mt-[-20px] px-[20px]">
          <button
            type="button"
            className={`flex-1 py-[12px] text-center text-[16px] font-[600] relative ${
              activeTab === 'event' ? 'text-[#1C1C1C]' : 'text-[#969696]'
            }`}
            onClick={() => setActiveTab('event')}
          >
            {t('community.event.title')}
            {activeTab === 'event' && (
              <div className="absolute bottom-[-1px] left-0 w-full h-[2px] bg-[#1C1C1C]" />
            )}
          </button>
          <button
            type="button"
            className={`flex-1 py-[12px] text-center text-[16px] font-[600] relative ${
              activeTab === 'qna' ? 'text-[#1C1C1C]' : 'text-[#969696]'
            }`}
            onClick={() => setActiveTab('qna')}
          >
            {t('common.qna')}
            {activeTab === 'qna' && (
              <div className="absolute bottom-[-1px] left-0 w-full h-[2px] bg-[#1C1C1C]" />
            )}
          </button>
          <button
            type="button"
            className={`flex-1 py-[12px] text-center text-[16px] font-[600] relative ${
              activeTab === 'freeBoard' ? 'text-[#1C1C1C]' : 'text-[#969696]'
            }`}
            onClick={() => setActiveTab('freeBoard')}
          >
            {t('community.freeboard.title')}
            {activeTab === 'freeBoard' && (
              <div className="absolute bottom-[-1px] left-0 w-full h-[2px] bg-[#1C1C1C]" />
            )}
          </button>
        </div>
      </div>

      <div
        ref={containerRef}
        className="w-full h-[100%] overflow-y-auto"
        style={{
          paddingTop: headerHeight,
          paddingBottom: '80px',
        }}
      >
        <div className="pageInner bg-[#FFF] min-h-[calc(100vh-60px)]">
          {activeTab === 'event' && <Event />}
          {activeTab === 'qna' && <Qna />}
          {activeTab === 'freeBoard' && <FreeBoardList />}
        </div>
      </div>
      <BottomNavigationV2 focusTab={BOTTOM_NAVI_V2.COMMUNITY} />
      <button
        type="button"
        className="z-50 w-[56px] h-[56px] fixed right-5 rounded-full flex items-center justify-center cursor-pointer shadow-[0_4px_4px_0_rgba(0,0,0,0.25)]"
        onClick={() => setWriteModalOpen(true)}
        style={{
          background: 'linear-gradient(180deg, #5EBEBB 0%, #468E8C 100%)',
          bottom: '100px', // 하단 네비게이션을 가리지 않도록 위치 조정
        }}
      >
        <img src={IcFloatingWrite} alt="write" />
      </button>

      {writeModalOpen && (
        <WirteModal open={writeModalOpen} onClose={() => setWriteModalOpen(false)} />
      )}
    </FullHeightContainer>
  );
}

export default CommunityPage;
